import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalPages.css";
import { useLang, LangToggle } from "../components/LangToggle";

const formBox = {
  borderLeft: "2px solid #111",
  padding: "8px 14px",
  margin: "12px 0",
};

export default function Refund() {
  const navigate = useNavigate();
  const [lang] = useLang();

  return (
    <div className="legalPage">
      <button className="legalPage__back" onClick={() => navigate("/")}>
        {lang === "fr" ? "retour" : "back"}
      </button>
      <LangToggle />

      <div className="legalPage__content">
        {lang === "fr" ? (
          <>
            <h1 className="legalPage__title">politique de remboursement</h1>
            <p className="legalPage__muted">Dernière mise à jour : 16/05/2026</p>

            <h2>1. Droit de rétractation (consommateurs UE)</h2>
            <p>
              Conformément au Code de la consommation (art. L221-18), vous disposez
              de 14 jours à compter de la réception de votre commande pour vous
              rétracter, sans avoir à motiver votre décision.
            </p>
            <p>
              Pour exercer ce droit, informez-nous avant l'expiration du délai de 14
              jours à hugombom2005@gmail.com en indiquant votre numéro de commande et
              une déclaration claire de votre décision de rétractation. Vous pouvez
              utiliser le modèle de formulaire de rétractation ci-dessous (son usage
              est facultatif).
            </p>
            <div style={formBox}>
              À l'attention de Ghetto Symphony — Hugo Armand Mbom, 35 Passage
              Clemenceau, 34000 Montpellier, France, hugombom2005@gmail.com :
              <br />
              <br />
              Je/Nous vous notifie/notifions par la présente ma/notre rétractation du
              contrat de vente portant sur la commande suivante :
              <br />
              — Numéro de commande : …
              <br />
              — Commandé le / reçu le : …
              <br />
              — Nom du/des consommateur(s) : …
              <br />
              — Adresse du/des consommateur(s) : …
              <br />
              — Date : …
            </div>

            <h2>2. Conditions de retour</h2>
            <p>Les articles doivent être retournés :</p>
            <ul>
              <li>Dans les 14 jours suivant la notification de votre rétractation</li>
              <li>Non portés, non lavés, en état d'origine</li>
              <li>Avec l'emballage d'origine le cas échéant</li>
            </ul>
            <p>
              Les articles visiblement utilisés, endommagés (hors défaut de
              fabrication) ou retournés hors délai ne seront pas acceptés.
            </p>

            <h2>3. Comment initier un retour</h2>
            <p>Envoyez un email à hugombom2005@gmail.com avec :</p>
            <ul>
              <li>Votre numéro de commande</li>
              <li>Le motif du retour</li>
              <li>Des photos si l'article est défectueux ou endommagé</li>
            </ul>
            <p>
              Nous vous répondrons avec les instructions de retour sous 3 jours
              ouvrés.
            </p>

            <h2>4. Frais de retour</h2>
            <ul>
              <li>
                Les frais de retour sont à la charge du client, sauf si l'article est
                défectueux ou en cas d'erreur d'expédition de notre part.
              </li>
              <li>
                En cas d'erreur de notre part ou d'article défectueux, nous prenons
                en charge ou remboursons les frais de retour.
              </li>
            </ul>

            <h2>5. Remboursements</h2>
            <p>
              Après réception et vérification de l'article retourné, nous vous
              informons par email de la décision. Si le retour est approuvé, le
              remboursement est effectué sur votre moyen de paiement d'origine dans un
              délai de 14 jours. Les délais de traitement bancaire peuvent varier.
            </p>
            <p>
              Les frais d'expédition initiaux ne sont remboursés que si vous exercez
              votre droit de rétractation dans le délai légal, ou en cas d'erreur de
              notre part.
            </p>

            <h2>6. Articles défectueux ou erronés</h2>
            <p>
              Si vous recevez un article défectueux ou erroné, contactez-nous
              immédiatement à hugombom2005@gmail.com avec votre numéro de commande et
              des photos. Nous organiserons un remplacement ou un remboursement
              intégral sans frais pour vous.
            </p>

            <h2>7. Drops limités &amp; précommandes</h2>
            <p>
              Si votre commande a été passée en précommande et que vous souhaitez
              l'annuler avant son expédition, contactez hugombom2005@gmail.com dès que
              possible. Nous ferons notre possible pour accéder aux demandes
              d'annulation avant que la commande n'entre en production ou en
              expédition.
            </p>

            <h2>8. Contact</h2>
            <p>
              Pour toute demande de retour ou de remboursement :
              hugombom2005@gmail.com
            </p>
          </>
        ) : (
          <>
            <h1 className="legalPage__title">refund policy</h1>
            <p className="legalPage__muted">Last update: 16/05/2026</p>

            <h2>1. Right of withdrawal (EU consumers)</h2>
            <p>
              In accordance with French consumer law (Code de la consommation,
              art. L221-18), you have the right to withdraw from your purchase within
              14 days of receiving your order, without giving any reason.
            </p>
            <p>
              To exercise this right, notify us before the 14-day deadline at
              hugombom2005@gmail.com with your order number and a clear statement of
              your decision to withdraw. You may use the model withdrawal form below
              (its use is optional).
            </p>
            <div style={formBox}>
              To Ghetto Symphony — Hugo Armand Mbom, 35 Passage Clemenceau, 34000
              Montpellier, France, hugombom2005@gmail.com:
              <br />
              <br />
              I/We hereby notify you of my/our withdrawal from the contract of sale
              for the following order:
              <br />
              — Order number: …
              <br />
              — Ordered on / received on: …
              <br />
              — Name of consumer(s): …
              <br />
              — Address of consumer(s): …
              <br />
              — Date: …
            </div>

            <h2>2. Return conditions</h2>
            <p>Items must be returned:</p>
            <ul>
              <li>Within 14 days of notifying us of your withdrawal</li>
              <li>Unworn, unwashed, and in original condition</li>
              <li>With original packaging where applicable</li>
            </ul>
            <p>
              Items that are visibly used, damaged (other than a manufacturing
              defect), or returned outside the deadline will not be accepted.
            </p>

            <h2>3. How to start a return</h2>
            <p>Email hugombom2005@gmail.com with:</p>
            <ul>
              <li>Your order number</li>
              <li>Reason for return</li>
              <li>Photos if the item is defective or damaged</li>
            </ul>
            <p>We will reply with return instructions within 3 business days.</p>

            <h2>4. Return shipping costs</h2>
            <ul>
              <li>
                Return shipping is at the customer's expense, unless the item is
                defective or we made a shipping error.
              </li>
              <li>
                If we made an error or the item is defective, we will cover or
                reimburse return shipping costs.
              </li>
            </ul>

            <h2>5. Refunds</h2>
            <p>
              Once we receive and inspect the returned item, we will notify you by
              email of the outcome. If the return is approved, the refund will be
              issued to your original payment method within 14 days. Bank processing
              times may vary.
            </p>
            <p>
              Original shipping costs are refunded only if you exercise your right of
              withdrawal within the legal period, or if the error is on our side.
            </p>

            <h2>6. Defective or incorrect items</h2>
            <p>
              If you receive a defective or incorrect item, contact us immediately at
              hugombom2005@gmail.com with your order number and photos. We will
              arrange a replacement or full refund at no cost to you.
            </p>

            <h2>7. Limited drops &amp; preorders</h2>
            <p>
              If your order was placed as a preorder and you wish to cancel before it
              ships, contact hugombom2005@gmail.com as soon as possible. We will do
              our best to accommodate cancellation requests before the order enters
              production or shipping.
            </p>

            <h2>8. Contact</h2>
            <p>For any return or refund request: hugombom2005@gmail.com</p>
          </>
        )}
      </div>
    </div>
  );
}
